import httpClient from "../../api/config";
import _isEmpty from 'lodash/isEmpty';
import _chunk from 'lodash/chunk';


const resetDefaultState = () => ({
	selectedKeywords: [],
	currentPage: 1,
	selectedFbTopMention: [],
	sortByType: "time",
	sortByOrder: "desc",
	status: null
});

let mention = {
	namespaced: true,

	state: {
		mentionPageReady: false,
		summaryReady: true,
		postReady: true,
		pageFanCount: {},
		monitorFanCount: [],
		monitorFacebookPosts: [],
		monitorSinglePost: {},
		monitorSinglePostComments: [],
		monitorSinglePostCommentsCount: undefined,
		selectedKeywords: [],
		currentPage: 1,
		selectedFbTopMention: [],
		sortByType: "time",
		sortByOrder: "desc",
		status: null,
		searchTerm: "",
		growthRate: {
			range_count: ["2020-12-25", 0, "2021-01-01", 0.68, "2021-01-08", 0.35, "2021-01-15", 0, "2021-01-22", 1.55],
			total_page_likes: { start: "2021-01-16", end: "2021-01-22", count: 708357, rate: 1.55 },
			new_page_likes: { start: "2021-01-16", end: "2021-01-22", count: 10816 }
		}
	},

	actions: {

		fetchPageFanCount({ commit }, { monitor_uuid, page_id }) {
			return httpClient.get(`/v2/monitor/${monitor_uuid}/page-fan-counts/${page_id}`)
				.then(({ data }) => {
					commit('setPageFanCount', data)
				});
		},

		fetchMonitorFanCount({ commit }, { monitor_uuid }) {
			return httpClient.get(`/v2/monitor/${monitor_uuid}/fan-counts/latest`)
				.then(({ data }) => {
					commit('setMonitorFanCount', data)
				});
		},

		fetchMonitorFacebookPosts({ commit }, { monitor_uuid, skip = 0, limit = 10, timerange, sort = null, watched = null, keywords = null, pages = null, term = null }) {
			let data = { timerange, sort, limit, skip, watched, keywords, pages, term };
			return httpClient.post(`/elastic/monitor/${monitor_uuid}/posts`, data)
				.then(({ data }) => {
					commit('setMonitorFacebookPosts', data);
				});
		},

		fetchMonitorSinglePost({ commit }, { post_id, monitor_uuid }) {
			return httpClient.get(`/elastic/monitor/${monitor_uuid}/post/${post_id}`)
				.then(({ data }) => {
					commit('setMonitorSinglePost', data)
				})
		},

		fetchMonitorPostComments({ commit }, { data = { skip: 0, term: null, category: null, order: null }, post_id, monitor_uuid }) {
			data.limit = 10;
			return httpClient.post(`/elastic/monitor/${monitor_uuid}/post/${post_id}/comment`, data)
				.then(({ data }) => {
					commit('setMonitorSinglePostComments', data)
					commit('setMonitorSinglePostCommentsCount', data)
				})
		},

		updatePostStatus({ commit }, data) {
			return httpClient.put(`/elastic/monitor/post/status`, data)
				.then(({ data }) => {
					/*  backend service required this condition.
						if you want to remove this condition plz discuss with backend engineer
					 */
					if (data && data.message !== "Successfully Updated Post Status") {
						commit('error/setErrorDialogStatus', true, { root: true });
						commit('error/setErrorDialogMessage', data.message, { root: true })
					}
					return data;
				}).catch(err => {
					commit('error/setErrorDialogStatus', true, { root: true });
					commit('error/setErrorDialogMessage', "Error Occour when update posts's status", { root: true });
					return Promise.reject(err);
				})
		},

		fetchFanCountGrowthRate({ commit }, { id }) {
			return httpClient.get(`/v2/pages/${id}/growth-rate`)
				.then(({ data }) => {
					commit('setGrowthRate', data)
				})
		}

	},

	getters: {
		getTotalMention(state, getters, rootState) {
			let fbposts = rootState.facebookSummary.fbposts || {};
			let range_count = fbposts.range_count || [];
			return _chunk(range_count, 2);
		},

		monitorFacebookPosts(state) {
			let { posts } = state.monitorFacebookPosts
			return posts
		},

		monitorFacebookPostCount(state) {
			let { count } = state.monitorFacebookPosts
			return count
		},

		facebookTopMention(state, getters, rootState, rootGetters) {
			return rootGetters.facebookPagesAndCount("fbposts");
		}
	},

	mutations: {

		setPageFanCount(state, fancount) {
			state.pageFanCount = fancount;
		},

		setMonitorFanCount(state, fancount) {
			state.monitorFanCount = fancount;
		},

		setMonitorFacebookPosts(state, posts) {
			state.monitorFacebookPosts = posts
		},

		setMonitorSinglePost(state, post) {
			state.monitorSinglePost = post
		},

		setMonitorSinglePostComments(state, { comments }) {
			state.monitorSinglePostComments = comments
		},

		setMonitorSinglePostCommentsCount(state, { count }) {
			state.monitorSinglePostCommentsCount = count
		},

		setMentionPageReady(state, status) {
			state.mentionPageReady = status;
		},

		setSelectedKeywords(state, keyword) {
			state.selectedKeywords = keyword
		},

		setSummaryReady(state, status) {
			state.summaryReady = status
		},

		setPostReady(state, status) {
			state.postReady = status;
		},

		setCurrentPage(state, pageNo) {
			state.currentPage = pageNo;
		},

		setSelectedFbTopMention(state, pages) {
			state.selectedFbTopMention = pages
		},

		setSortByType(state, type) {
			state.sortByType = type;
		},

		setSortByOrder(state, order) {
			state.sortByOrder = order;
		},

		setPostStatus(state, status) {
			state.status = status;
		},

		setDefaultMentionState(state) {
			Object.assign(state, resetDefaultState());
		},

		setSearchTerm(state, term) {
			state.searchTerm = term;
		},

		setGrowthRate(state, growthRate) {
			state.growthRate = growthRate;
		}
	}
}

export default mention
